import React from 'react';

interface AllocationItem {
  value: number;
  label: string;
  color: string;
}

interface AllocationBarProps {
  items: AllocationItem[];
  maxAllowedTotal: number;
  height?: number;
  borderRadius?: number;
  isOverAllocated?: boolean;
}

const AllocationBar: React.FC<AllocationBarProps> = ({
  items,
  maxAllowedTotal,
  height = 18,
  borderRadius = 16,
  isOverAllocated = false
}) => {
  return (
    <div
      className="w-full flex overflow-hidden"
      style={{ height, borderRadius, background: '#E9ECEF', border: isOverAllocated ? '1.5px solid #E8507E' : 'none' }}
    >
      {items.map((item, idx) => {
        const widthPercent = maxAllowedTotal > 0 ? (item.value / maxAllowedTotal) * 100 : 0;
        return (
          <div
            key={item.label + idx}
            style={{
              width: `${widthPercent}%`,
              background: item.color,
              height: '100%',
              borderTopLeftRadius: idx === 0 ? borderRadius : 0,
              borderBottomLeftRadius: idx === 0 ? borderRadius : 0,
              borderTopRightRadius: idx === items.length - 1 ? borderRadius : 0,
              borderBottomRightRadius: idx === items.length - 1 ? borderRadius : 0,
              transition: 'width 0.3s'
            }}
          />
        );
      })}
    </div>
  );
};

export default AllocationBar;
